<template>
  <div id="layout">
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
      <div class="container-fluid">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <a class="navbar-brand pt-0" href="#">
          <img src="../../static/img/numisma-logo.png" class="navbar-brand-img" alt="Numisma">
        </a>
        <ul class="nav align-items-center d-md-none">
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="media align-items-center">
                <span v-if="user" class="photoURL avatar avatar-sm rounded-circle" :style="{ 'background-image': 'url('+user.photoURL+')' }">
                </span>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
              <!-- Menu -->
              <Menu key="Default" />
              <!-- /Menu -->
            </div>
          </li>
        </ul>

        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <div class="navbar-collapse-header d-md-none">
            <div class="row">
              <div class="col-6 collapse-brand">
                <a href="#">
                  <img src="../../static/img/numisma-logo.png">
                </a>
              </div>
              <div class="col-6 collapse-close">
                <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle sidenav">
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </div>
          <!-- Navigation -->
          <Nav />
          <!-- /Navigation -->
        </div>
      </div>
    </nav>
    <div class="main-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Nav from './Nav'
import Menu from './Menu'

export default {
  name: 'Default',
  components: { Nav, Menu },
  created () {
    this.$store.dispatch('fetchUser')
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/Default.vue